import React from "react";
import { Routes, Route } from "react-router-dom";
import { useSelector } from "react-redux";
import Home from "./home/home";
import Dashboard from "./performance/dashboard/dashboard";
import Sponsored from "./sponsored/sponsored";
import BidSetting from "./sponsored/bidSetting";
import LegalProfessionals from "./professionals/professionals";
import Category from "./addLawyer/category";
import BarNumber from "./addLawyer/barNumber";
import BasicInformation from "./addLawyer/basicInformation";
import Education from "./addLawyer/education";
import AboutYou from "./addLawyer/aboutYou";
import ProfilePhoto from "./addLawyer/profilePhoto";
import SetupLocations from "./addLawyer/setupLocations";
import CaseHighlights from "./addLawyer/caseHighlights";
import WorkExperience from "./addLawyer/workExperience";
import MultiCalendarView from "./calendar/calendar";
import SettingsPage from "./settings/settingsPage";
import SetHours from "./calendar/setHours";
import AppointmentReport from "./performance/reports/appointmentReport";
import PaymentOnboarding from "./payment/paymentOnboarding";
import Return from "./payment/return";
import Refresh from "./payment/refresh";
import ModernInbox from "./inbox/newInbox";
import FormEditor from "./intake/formEditor/formEditor";
import FormPreview from "./settings/components/formPreview";
import Intake from "./home/onboarding/intake";
import Location from "./home/onboarding/location";
import VisitReason from "./home/onboarding/visitReason";
import PaymentSuccess from "./settings/paymentSuccess";
import FirmActivationPage from "./home/onboarding/activateFirm";
import LawyerActivationPage from "./home/onboarding/activateLawyer";
import CasePage from "./case/CasePage";

const LawyerRoutes = () => {
  return (
    <Routes>
      <Route path=":userId/home" element={<Home />} />
      <Route path="/performance/dashboard" element={<Dashboard />} />
      <Route
        path="/performance/appointment-reports"
        element={<AppointmentReport />}
      />
      <Route path="/setup/add" element={<Category />} />
      <Route path="/setup/case-highlights" element={<CaseHighlights />} />
      <Route path="/setup/bar-details" element={<BarNumber />} />
      <Route path="/setup/basic-info" element={<BasicInformation />} />
      <Route path="/setup/locations" element={<SetupLocations />} />
      <Route path="/setup/payment" element={<PaymentOnboarding />} />
      <Route path="/setup/availability" element={<SetHours />} />
      <Route path="/setup/education" element={<Education />} />
      <Route path="/setup/about-you" element={<AboutYou />} />
      <Route path="/setup/profile-photo" element={<ProfilePhoto />} />
      <Route path="/sponsored" element={<Sponsored />} />
      <Route path="/sponsored/bid-setting" element={<BidSetting />} />
      <Route path="/settings" element={<SettingsPage />} />
      <Route path="/settings/form-preview" element={<FormPreview />} />
      <Route path="/settings/payment-success" element={<PaymentSuccess />} />
      <Route path="/inbox" element={<ModernInbox />} />
      <Route path="/professionals" element={<LegalProfessionals />} />
      <Route path="/setup/work-experience" element={<WorkExperience />} />
      <Route path="/setup/location" element={<Location />} />
      <Route path="/setup/visit-reasons" element={<VisitReason />} />
      <Route path="/intake/forms" element={<Intake />} />
      <Route path="/setup/activate-firm" element={<FirmActivationPage />} />
      <Route path="/setup/activate-profile" element={<LawyerActivationPage />} />

      <Route path="/calendar" element={<MultiCalendarView />} />
      <Route path="/case/:appointmentId" element={<CasePage />} />
      <Route
        path="/billing/onboarding-success/:connectedAccountId"
        element={<Return />}
      />
      <Route
        path="/billing/onboarding-refresh/:connectedAccountId"
        element={<Refresh />}
      />

      <Route path="/intake/form-builder" element={<FormEditor />} />
    </Routes>
  );
};

export default LawyerRoutes;
